module.exports = __webpack_public_path__ + "media/images/country_flags/ml-e57b5d382bdb493dc70d76dd6b5f6653.png";